export function $(queryString) {
  return document.querySelector(queryString) as HTMLElement;
}
